module.exports = __webpack_public_path__ + "img/message.cf6bed92.svg";